import { Component, ChangeDetectionStrategy, HostBinding, ViewEncapsulation, Input } from '@angular/core';

@Component({
    selector: 'eui-toolbar-item-user-profile',
    templateUrl: './toolbar-item-user-profile.component.html',
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.None,
})
export class EuiToolbarItemUserProfileComponent {
    @HostBinding() class = 'eui-toolbar-item-user-profile';

    @Input() hasWelcomeLabel = false;
    @Input() welcomeLabel = 'Welcome';
    @Input() impersonateLabel = 'impersonating';
    @Input() avatarUrl: string;
}
